var map = {
	"./15_happy.mp3": "ff58",
	"./16_sad.mp3": "ca60",
	"./18_angry.mp3": "bada",
	"./19_sleepy.mp3": "191b",
	"./20_hungry.mp3": "9ff0",
	"./21_scared.mp3": "bf95",
	"./M_Brilliant.mp3": "c6b3",
	"./M_Excellent.mp3": "831c",
	"./M_Fantastic.mp3": "4913",
	"./M_Great.mp3": "1906",
	"./M_Perfect.mp3": "d0e7",
	"./M_Think again.mp3": "8949",
	"./M_Try again.mp3": "73d9",
	"./M_Very good.mp3": "e184",
	"./M_Well done.mp3": "e560",
	"./M_Work harder.mp3": "69a2",
	"./click.mp3": "e888"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4a9a";